import React, { useMemo, useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import './Gallery.css';
import './Detail.css';
import './Info.css';
import { getProduct, productImageUrl } from '../utils/shopData';
import Plate from './Plate';
import Lightbox from './Lightbox';
import BuyButton from './BuyButton';

/* A product page is a project page with a price and a button. Same measure,
   same plates, same viewer, same credits table — reused for the specs. */
export default function ShopItem() {
  const { slug } = useParams();
  const product = getProduct(slug);
  const [lightbox, setLightbox] = useState(null);

  const plates = useMemo(() => {
    if (!product) return [];
    const head = product.hero ? [product.hero] : [];
    return head.concat(product.media || []);
  }, [product]);

  const stills = useMemo(
    () => plates.map((f) => productImageUrl(product, f)),
    [plates, product]
  );

  useEffect(() => { setLightbox(null); }, [slug]);

  if (!product) {
    return (
      <div className="home-container">
        <div className="body-text">Not found.</div>
      </div>
    );
  }

  return (
    <div>
      <div className="home-container">
        <div className="detail-intro">
          {(product.overview || []).map((para, i) => (
            <div className="body-text" key={i} style={i ? { marginTop: '16px' } : undefined}>
              {para}
            </div>
          ))}
        </div>

        <BuyButton buyButtonId={product.buyButtonId} soldOut={product.soldOut} />

        {stills.map((url, i) => (
          <Plate
            key={url + i}
            src={url}
            alt=""
            eager={i === 0}
            onOpen={() => setLightbox(i)}
          />
        ))}

        {product.details && product.details.length > 0 && (
          <div className="credits-table shop-details">
            <div className="credits-row credits-head">
              <div className="credits-cell">Detail</div>
              <div className="credits-cell">Spec</div>
            </div>
            {product.details.map(([k, v], i) => (
              <div className="credits-row" key={i}>
                <div className="credits-cell">{k}</div>
                <div className="credits-cell">{v}</div>
              </div>
            ))}
          </div>
        )}

        <div className="arrow-container">
          <Link to="/shop" className="body-text">Back to shop</Link>
        </div>
      </div>

      {lightbox !== null && (
        <Lightbox
          images={stills}
          index={lightbox}
          onIndex={setLightbox}
          onClose={() => setLightbox(null)}
        />
      )}
    </div>
  );
}
